import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Grid2,
  Container,
  Typography,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PasswordDTO, PasswordDTOInit } from "../../model/entity/PasswordDTO";
import { getFetcher, putFetcher } from "../../components/Fetchers";
import { notifErr, notifOk } from "../../components/Functions";
import handleAxiosError from "../../components/ErrorHandler";
import { AppUserDTO } from "../../model/entity/AppUserDTO";
import { Loading } from "../../components/Loading";

const PasswordChange = () => {
  const navigate = useNavigate();
  const [appUserDTO, setAppUserDTO] = useState<AppUserDTO | null>(null);
  const [passwordDTO, setPasswordDTO] = useState<PasswordDTO>(PasswordDTOInit);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getFetcher(
          `${process.env.REACT_APP_API_URL}/auth/me`
        );
        setAppUserDTO(response.data);
      } catch (err) {
        notifErr(handleAxiosError(err));
      }
    };

    fetchData();
  }, []);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPasswordDTO({ ...passwordDTO, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!appUserDTO) return;

    const config = {
      email: appUserDTO.email,
    };

    try {
      const response = await putFetcher(
        `${process.env.REACT_APP_API_URL}/auth/change-password`,
        passwordDTO,
        config
      );
      notifOk(response.data);
      navigate("/account");
    } catch (err) {
      notifErr(handleAxiosError(err));
    }
  };

  if (!appUserDTO) return <Loading />;

  return (
    <Container
      maxWidth="xs"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pb: "2rem",
      }}
    >
      <Paper elevation={3} sx={{ padding: "1.5rem" }}>
        <Typography variant="h5" sx={{ marginBottom: "1.5rem" }}>
          Změna hesla
        </Typography>
        <Grid2 container spacing={3} size={{ xs: 12, md: 6 }}>
          <Grid2 size={{ xs: 12 }}>
            <TextField
              fullWidth
              size="small"
              type="password"
              label="Staré heslo"
              required
              name="oldPwd"
              value={passwordDTO.oldPwd}
              onChange={handleInputChange}
            />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <TextField
              fullWidth
              size="small"
              type="password"
              label="Nové heslo"
              required
              name="newPwd"
              value={passwordDTO.newPwd}
              onChange={handleInputChange}
            />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <TextField
              fullWidth
              size="small"
              type="password"
              label="Potvrdit nové heslo"
              required
              name="newPwdConfirm"
              value={passwordDTO.newPwdConfirm}
              onChange={handleInputChange}
            />
          </Grid2>

          <Grid2
            size={{ xs: 12 }}
            sx={{ display: "flex", justifyContent: "right", gap: ".75rem" }}
          >
            <Button
              className="cancelBtn"
              variant="outlined"
              onClick={() => navigate("/account")}
            >
              Zrušit
            </Button>
            <Button
              className="submitBtn"
              variant="outlined"
              onClick={handleSubmit}
            >
              Uložit
            </Button>
          </Grid2>
        </Grid2>
      </Paper>
    </Container>
  );
};

export default PasswordChange;
